import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">视频分类</h2>
          <Link to="/category/movie" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center justify-center p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{cat.count.toLocaleString()}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}